import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useLoader } from "../../Loader";

function RejectModal({ show, onHide, onReject, selectedOrder ,getPurchaseOrder ,action}) {
  const [comment, setComment] = useState("");
  const { startLoader, stopLoader } = useLoader();

  const handleReject = () => {
    startLoader()
    var bodyFormData = new FormData();
    bodyFormData.append("po_id", selectedOrder.id);
    bodyFormData.append("status", action);
    bodyFormData.append("reject_reason", comment);

    utils
      .callAPI("post", `purchaseorder/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getPurchaseOrder();
          onHide()
          setComment()
          stopLoader()
        } else {
          getPurchaseOrder();
          onHide()
          setComment()
          stopLoader()
        }
      })
      .catch((err) => {
        getPurchaseOrder();
        stopLoader()
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{`${action == 'reject' ? 'Reject':'Hold'}`} Purchase Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="rejectComment">
            <Form.Label>Comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={`Enter your reason for ${action == 'reject' ? 'Reject':'Hold'}`}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant={action == 'reject' ? 'danger':'warning'} onClick={handleReject}>
        {action == 'reject' ? 'Reject':'Hold'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RejectModal;
